/* eslint-disable max-lines */
 
import $ from 'jquery';
import ko from 'knockout';
import '../../../../jsscripts/jquery/knockout/knockout.mapping';
import {first} from '../../../utils/array';
import ImageViewModel from '../viewmodels/imageviewmodel';
import VideoViewModel from '../viewmodels/videoviewmodel';
import {hasProperty, keyValueMatchCount, propEquals} from '../../../utils/object';
import productClassMessaging from '../shared/productclassmessaging';

const accountTypes = {
        UNKNOWN: 0,
        HORSE: 1,
        DOG: 2,
        CAT: 3,
        ME: 5,
        NOT_ANIMAL: 6
    },
    freeShippingTypes = {
        NONE: 'n',
        SHIPPING: 's',
        RETURN: 'r',
        BOTH: 'b'
    };

let meAccount = {
    AccountId: 0,
    Name: 'Me',
    AccountType: accountTypes.ME
};

function ProductClassViewModel(data, config) {
    var mapping = {
        videos: {
            create: function(options) {
                return new VideoViewModel(options.data);
            }
        },
        images: {
            create: function(options) {
                return new ImageViewModel(options.data);
            }
        }
    };

    ko.mapping.fromJS(data, mapping, this);

    this.coliCareForPouchesEnabled = Boolean(config?.coliCareForPouchesEnabled);
    this.isPerksEligible = ko.observable(Boolean(config?.isPerksEligible));

    this.productClassMessaging = productClassMessaging({
        messages: data.productClassMessaging || [],
        excludeFromPromo: data.excludeFromPromo,
        isPerksEligible: this.isPerksEligible()
    });

    this.userDetectedLocation = ko.observable();
    this.canShowOrderControl = ko.observable(true);
    this.orderControlHiddenExplanation = ko.observable();
    this.showCAProp65Warning = ko.observable(false);

    const prop65Subscription = this.userDetectedLocation.subscribe(location => {
        this.showCAProp65Warning(location.state === 'California' && this.isProp65());

        prop65Subscription.dispose();
    });

    this.quantity = ko.observable(1);
    this.selectedProduct = ko.observable();
    this.selectedImage = ko.observable();
    this.selectedAttributes = ko.observable({});
    this.selectedProductId = ko.observable();
    this.selectedRecipientName = ko.observable();
    this.selectedRecipientNameOption = ko.observable();
    this.selectedRecipientNameInput = ko.observable();
    this.recipientTypeName = capitalize(this.recipientType());
    this.shouldShowAddRecipient = ko.observable(false);
    this.allRecipients = ko.observableArray();
    this.isSPEUser = ko.observable(false);
    this.isLoggedIn = ko.observable(false);
    this.isEligibleForSubscription = ko.observable();

    this.selectedRecipientNameOption.subscribe(this.selectedRecipientName);
    this.selectedRecipientNameInput.subscribe(
        function(recipient) {
            if (recipient) {
                this.selectedRecipientName(recipient.trim());
            }
        }.bind(this)
    );

    this.pakRecipients = ko.computed(
        function() {
            return this.allRecipients().filter(this.isCanine ? isCanineAccount : isEquineAccount);
        }.bind(this)
    );

    this.selectedPrice = ko.computed(
        function() {
            var product = this.selectedProduct();
            return product && product.type && product.type() === 'tes'
                ? decorateProductPrice(product.price)
                : this.price;
        }.bind(this)
    );

    this.hasMemberDiscount = ko.computed(
        function() {
            var priceModel = this.selectedPrice();
            return priceModel.type() === 'member';
        }.bind(this)
    );

    this.productImages = this.images().filter(propEquals('type', 'product')); 

    if (this.freeShipping) {
        this.hasFreeShipping = new RegExp(
            '^' + freeShippingTypes.SHIPPING + '|' + freeShippingTypes.BOTH + '$',
            'gi'
        ).test(this.freeShipping());
        this.hasFreeReturnShipping = new RegExp(
            '^' + freeShippingTypes.RETURN + '|' + freeShippingTypes.BOTH + '$',
            'gi'
        ).test(this.freeShipping());
    }

    this.setRecipientName = function(name) {
        this.selectedRecipientNameOption(name);
        this.selectedRecipientNameInput(name);
        this.selectedRecipientNameInput.valueHasMutated();
    };

    this.addRecipient = function(recipient) {
        if (recipient && !this.allRecipients().some(propEquals('Name', recipient.Name))) {
            this.allRecipients.push(recipient);

            this.setRecipientName('');

            if (!this.isSPEUser()) {
                this.setRecipientName(recipient.Name);
                this.shouldShowAddRecipient(false);
            }
        }
    };

    this.selectedRecipient = ko.computed(
        function() {
            var name = this.selectedRecipientName();
            return first(this.allRecipients(), propEquals('Name', name));
        }.bind(this)
    );

    this.canUseMeAccount = ko.computed(() => {
        const product = this.selectedProduct();
        const isTes = !!product && product.isTes;

        if (this.coliCareForPouchesEnabled) {
            return isTes && !product.isPouch();
        }

        return isTes;
    });

    this.selectedProduct.subscribe(
        function(product) {
            this.isEligibleForSubscription(product && product.isEligibleForSubscription());
            var pakRecipients = this.pakRecipients();
            this.setRecipientName(
                this.isSPEUser() && this.canUseMeAccount()
                    ? meAccount.Name
                    : pakRecipients.length === 1 && !this.shouldShowAddRecipient()
                    ? pakRecipients[0].Name
                    : this.selectedRecipientName() !== meAccount.Name
                    ? this.selectedRecipientName()
                    : ''
            );
        }.bind(this)
    );

    this.nameAlreadyExists = ko.computed(
        function() {
            var selectedRecipient = this.selectedRecipientName(),
                name = selectedRecipient ? selectedRecipient.toLowerCase() : '',
                isExistingName =
                    !!name &&
                    this.allRecipients().some(function(recipient) {
                        return !!recipient.Name && recipient.Name.toLowerCase() === name;
                    });

            if (isExistingName) {
                return isRecipientCorrectAnimalType(this.selectedRecipient(), this.isCanine);
            }

            return false;
        }.bind(this)
    );

    this.hasRecipients = ko.computed(
        function() {
            return this.allRecipients().filter(this.isCanine ? isCanineAccount : isEquineAccount).length > 0;
        }.bind(this)
    );

    this.imageWithAttributeMatches = function(images, attributes) {
        var imagesWithMatchCounts = images.map(imageMatches(attributes)),
            hasMatches = imagesWithMatchCounts.some(function(image) {
                return image.matches > 0;
            });

        return (!hasMatches ? imagesWithMatchCounts : imagesWithMatchCounts.sort(sortByMatches))[0];
    };

    this.toggleShouldShowAddRecipient = function() {
        this.shouldShowAddRecipient(!this.shouldShowAddRecipient());

        if (
            this.isSPEUser() &&
            !this.shouldShowAddRecipient() &&
            this.canUseMeAccount()
        ) {
            this.setRecipientName(meAccount.Name);
        } else {
            this.setRecipientName('');
        }
    }.bind(this);

    $.post('/api/legacyshoppingcart/GetCustomerDto', {isEquineBuilder: true}).done(
        function(customerDto) {
            var recipients = customerDto.Accounts.filter(function(recipient) {
                    return !recipient.Deleted;
                }),
                hasRecipients = recipients.length;

            this.isSPEUser(customerDto.IsSpeUser);
            this.isLoggedIn(customerDto.IsLoggedIn);
            this.shouldShowAddRecipient(!customerDto.IsLoggedIn && !hasRecipients);
            this.setInitialRecipient(recipients, hasRecipients);
        }.bind(this)
    );

    this.setInitialRecipient = function(recipients, hasRecipients) {
        if (hasRecipients) {
            this.allRecipients(this.isSPEUser() ? [meAccount].concat(recipients) : recipients);

            if (this.isSPEUser() && this.canUseMeAccount()) {
                this.setRecipientName(meAccount.Name);
            } else if (this.pakRecipients().length === 1) {
                this.setRecipientName(this.pakRecipients()[0].Name);
            }
        } else if (this.isSPEUser() && this.canUseMeAccount()) {
            this.setRecipientName(meAccount.Name);
        } else {
            this.setRecipientName('');
        }
    }.bind(this);

    this.organizations = ko.observableArray();

    this.organizationText = ko.computed(
        function() {
            return this.organizations().join(', ');
        }.bind(this)
    );

    this.recentlyViewedProducts = ko.observableArray([]);

    this.updateProductETA = function(id, sku, product, data) {
        var GENERAL_PREFERENCE_TYPE_ID = 3,
            zip = hasProperty(smartPak, 'preferredLocationCookie.PreferredZipCode')
                ? smartPak.preferredLocationCookie.PreferredZipCode
                : '',
            customData = data ? JSON.parse(data) : {},
            type = customData.PreferenceTypeId || GENERAL_PREFERENCE_TYPE_ID;

        return $.get(getProductETAUrl(id, sku, zip, type, !!data)).done(function(response) {
            product.estimatedArrivalDate(response.replace(/"/gi, ''));
        });
    };

    this.updateEstimatedArrivalDates = function() {
        var promises = this.products();

        if (this.customizationData) {
            getProductClassETAData(this.id(), this.customizationData()).done(function(data) {
                parseProductClassData(data, promises);
            });
        }
    };

    this.updateRecentlyViewedProducts = function(obj) {
        this.recentlyViewedProducts(obj);
    };

    if (smartPak.cdProfileCookie) {
        ['AQHA', 'IHSA', 'USEF'].forEach(
            function(organization) {
                if (smartPak.cdProfileCookie[organization]) {
                    this.organizations.push(organization);
                }
            }.bind(this)
        );
    }
}

// eslint-disable-next-line max-params
function getProductETAUrl(id, sku, zip, type, saved) {
    return (
        '/productclasspage/getestimatedarrivaldate?productClassId=' +
        id +
        '&productId=' +
        sku +
        '&postalCode=' +
        zip +
        '&customizationType=' +
        type +
        '&hasCustomizationBeenSaved=' +
        saved
    );
}

function getProductClassETAUrl(id, zip, type, saved) {
    return (
        '/productclasspage/getproductclassestimatedarrivaldate?productClassId=' +
        id +
        '&postalCode=' +
        zip +
        '&customizationType=' +
        type +
        '&hasCustomizationBeenSaved=' +
        saved
    );
}

function getProductClassETAData(id, data) {
    var GENERAL_PREFERENCE_TYPE_ID = 3,
        zip = hasProperty(smartPak, 'preferredLocationCookie.PreferredZipCode')
            ? smartPak.preferredLocationCookie.PreferredZipCode
            : '',
        customData = data ? JSON.parse(data) : {},
        type = customData.PreferenceTypeId || GENERAL_PREFERENCE_TYPE_ID;

    return $.get(getProductClassETAUrl(id, zip, type, !!data));
}

function parseProductClassData(data, promises) {
    var parsed = JSON.parse(data);
    parsed.productAvailabilityModels.forEach(function(availabilityModel) {
        setProductEstimatedArrivalDate(availabilityModel, promises);
    });
}

function setProductEstimatedArrivalDate(availabilityModel, promises) {
    var product = ko.utils.arrayFirst(promises, function(item) {
        return item.id() === availabilityModel.productId;
    });

    if (product) {
        product.estimatedArrivalDate(availabilityModel.estimatedArrivalDate);
    }
}

function isCanineAccount(account) {
    return account && (account.AccountType === accountTypes.UNKNOWN || account.AccountType === accountTypes.DOG);
}

function isEquineAccount(account) {
    return account && (account.AccountType === accountTypes.UNKNOWN || account.AccountType === accountTypes.HORSE);
}

function capitalize(str) {
    return str.substring(0, 1).toUpperCase() + str.substring(1);
}

function currencyToNumber(str) {
    return +str.replace(/(^\$|,|\s)/g, '');
}

function imageMatches(attributes) {
    return function(image) {
        return {
            image: image,
            matches: keyValueMatchCount(image.attributes, attributes)
        };
    };
}

function sortByMatches(a, b) {
    return a.matches === b.matches ? 0 : a.matches > b.matches ? -1 : 1;
}

function decorateProductPrice(price) {
    var unwrappedPrice = ko.toJS(price);

    unwrappedPrice.current = '$' + currencyToNumber(unwrappedPrice.current).toFixed(2);
    unwrappedPrice.original = '$' + currencyToNumber(unwrappedPrice.original).toFixed(2);

    return ko.mapping.fromJS(unwrappedPrice);
}

function isRecipientCorrectAnimalType(recipient, isCanine) {
    if (isCanine) {
        return isEquineAccount(recipient);
    }

    return isCanineAccount(recipient);
}

export default ProductClassViewModel;
